import { Injectable } from '@angular/core';
import { AuthService, ClaimTypes, JwtAuthService } from '@mydocma/auth';
import { BpConfigService } from './bp-config.service';

@Injectable({ providedIn: 'root' })
export class CoClientModeService {

  private centralCoClient: boolean;

  constructor(
    private readonly configService: BpConfigService,
    private readonly authService: AuthService
  ) {}

  isCentralCoClient(): boolean {
    if (this.centralCoClient === undefined) {
      this.centralCoClient = this.resolveCentralCoClient();
    }

    return this.centralCoClient;
  }

  private resolveCentralCoClient(): boolean {
    const coModuleId = this.configService.getConfig()?.coModuleId;
    if (!coModuleId) {
      console.warn('[co-client-mode] bpConfig.coModuleId is not set - running as a module client');
      return false;
    }

    const moduleId = this.readModuleIdClaim();
    if (!moduleId) {
      console.warn('[co-client-mode] the access token carries no module_id claim - running as a module client');
      return false;
    }

    if (this.normalizeId(coModuleId) !== this.normalizeId(moduleId)) {
      console.warn(`[co-client-mode] bpConfig.coModuleId "${coModuleId}" does not match the token module_id "${moduleId}" - running as a module client`);
      return false;
    }

    return true;
  }

  private readModuleIdClaim(): string {
    try {
      const claims = (this.authService as any as JwtAuthService).getAccessTokenClaims();
      return claims?.[ClaimTypes.module_id];
    } catch {
      return null;
    }
  }

  private normalizeId(id: string): string {
    return id?.trim().toLowerCase() ?? null;
  }
}
